module.exports = __webpack_public_path__ + "media/images/whatsapp-icon-white-012437e1.png";